export class Config {
  public apiEndpoint: string;
  public version: string;
  public contactMailCompte: string;
  public subjectMailCompte: string;
  public timeToDetectInactivity: number;
}
